<template>
    <div>
        <div id="home" class="px-4 pt-5 mt-5 text-center">
            <h1 class="display-5 fw-bold text-body-emphasis mb-2" style="color: #555555 !important;"> <b>Easy data curation,</b></h1>
            <h1 class="display-5 fw-bold text-body-emphasis mb-3"><b>Fast assessments</b></h1>
            <div class="col-lg-6 mx-auto">
                <p class="lead text-center">
                    <b class="read">
                        Store and manage all your appraisal documents online. Update your documents with ease. Submit appraisal documents online. Conduct reviews, assessments and appraisals online. No hassles from dealing with printing and errors.
                    </b> 
                </p>
                <div class="mx-5 pt-1">
                    <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mt-3">
                        <router-link to="/register">
                            <button v-if="!isLoggedIn" type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4">
                                Get Started
                            </button>
                        </router-link>
                        <router-link to="/login">
                            <button v-if="!isLoggedIn" type="button" class="btn btn-outline-secondary btn-lg px-4 rounded-4 signInBtn">Sign In</button>
                        </router-link>
                        <router-link v-if="isLoggedIn" to="/sectiona">
                            <button type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4">Appraisal Form</button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div id="homeListing">
            <div class="container homeListingContainer">
                <div class="row mx-lg-5">
                <div class="col-sm-6 mb-4 d-flex justify-content-center">
                    <div class="card homeCard">
                        <div class="card-body p-4 mx-1">
                            <div style="font-size: 50px; color: silver;">
                                <i class="fa-solid fa-gear p-3 rounded-4 homeCardIcon"></i>
                            </div>
                            <h5 class="card-title mt-4 text-center"><b>Better Productivity</b></h5>
                            <p class="card-text mb-4 text-center">Improve overall organisational productivity by automating staff assessment and appraisal processes.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 mb-4 d-flex justify-content-center">
                    <div class="card homeCard">
                        <div class="card-body p-4 mx-1">
                            <div style="font-size: 50px; color: silver;">
                                <i class="fa-solid fa-money-bill p-3 rounded-4 homeCardIcon"></i>
                            </div>
                            <h5 class="card-title mt-4 text-center"><b>Affordable Cost</b></h5>
                            <p class="card-text mb-4 text-center">Save the cost, stress and time of printing, storing and transporting multiple assessment and appraisal documents.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 mb-4 d-flex justify-content-center">
                    <div class="card homeCard">
                        <div class="card-body p-4 mx-1">
                            <div style="font-size: 50px; color: silver;">
                                <i class="fa-solid fa-rotate p-3 rounded-4 homeCardIcon"></i>
                            </div>
                            <h5 class="card-title mt-4 text-center"><b>Quick Updates</b></h5>
                            <p class="card-text mb-4 text-center">Update, store and submit various sizes of assessment and appraisal documents rapidly and with ease.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 mb-4 d-flex justify-content-center">
                    <div class="card homeCard pb-4">
                        <div class="card-body p-4 mx-1">
                            <div style="font-size: 47px; color: silver;">
                                <i class="fa-solid fa-people-group p-3 rounded-4 homeCardIcon"></i>
                            </div>
                            <h5 class="card-title mt-4 text-center"><b>Easy Collaboration</b></h5>
                            <p class="card-text text-center">Easily collaborate within assessment and appraisal panels by concurrently reviewing staff documents online.</p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div class="mx-4">
            <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5 mx-5">
                <router-link to="/register">
                    <button v-if="!isLoggedIn" type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4">
                        Get Started
                    </button>
                </router-link>
                <router-link to="/login">
                    <button v-if="!isLoggedIn" type="button" class="btn btn-outline-secondary btn-lg px-4 rounded-4 signInBtn">Sign In</button>
                </router-link>
                <router-link v-if="$store.state.user.staffType == 'Academic Teaching' && isLoggedIn" to="/sectiona">
                    <button type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4">Appraisal Form</button>
                </router-link>
                <router-link v-if="($store.state.user.staffType == 'Junior Non-academic' || $store.state.user.staffType == 'Senior Non-academic') && isLoggedIn" to="/section1">
                    <button type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4">Appraisal Form</button>
                </router-link>
            </div>
        </div>
        <div class="footer" style="padding: 100px;"></div>
        <div class="py-3" style="color: grey;">
            <small>
                &copy;{{ copyrightDate }} <b class="firaFooter">assess.org.ng</b>. All rights reserved.
            </small>     
        </div>
    </div>
</template>
<script>
import DataService from '../services/dataservice'

export default {
    name: 'home',
    emits: ['toggleLoader'],
    data() {
        return {
            email: '',
            firstName: '',
            middleName: '',
            lastName: '',
            loading: false,
            staffType: 'Staff Type',
            faculty: 'faculty',
            presentStatus: 'presentStatus'
        }
    },
    computed: {
        isLoggedIn() {
            return DataService.isLoggedIn();
        },
        copyrightDate() {
            const currentDate = new Date();
            return currentDate.getFullYear();
        }
    },
    methods: {
        setPresentStatus() {
            this.presentStatus = 'presentStatus'
        }
    }
}
</script>
